import React, { useEffect, useState } from 'react'
import EligibilityQuestionFishingTruckView from './components/EligibilityQuestionFishingTruckView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const EligibilityQuestionFishingTruck = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('eligibility-fishing-truck', 'Renew your Vehicle Permit', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <EligibilityQuestionFishingTruckView setIsError={setIsError} />
}

export default withTranslation('common')(EligibilityQuestionFishingTruck)
